module.exports = __webpack_public_path__ + "img/chargerAlt.55231787.svg";